import './PrivacyPage.css';

export default function PrivacyPage() {
  return (
    <main className="privacy">
      <div className="container container--narrow">
        <h1>Privacy Policy</h1>
        <p className="privacy__note">Coming soon.</p>
        <a href="/" className="btn btn-secondary">Back to home</a>
      </div>
    </main>
  );
}
